import { Circle } from 'react-leaflet'
  

interface RangeProp {
    position: [number, number],
    radius: number
}

export function Range(props : RangeProp){
    return(
      <Circle center={props.position} interactive={false} radius={props.radius} opacity={0.25} fillOpacity={0.2}></Circle>
    )
}